/**
* Event Countdown JS
* -----------------------------------------------------------------------------
*
* All the JS for the Event Countdown component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'event-countdown',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      const second = 1000;
      const minute = second * 60;
      const hour = minute * 60;
      const day = hour * 24;

      let today = new Date();
      const dd = String( $( '.countdown' ).attr( 'data-day' ) ).padStart( 2, '0' );
      const mm = String( $( '.countdown' ).attr( 'data-month' ) ).padStart( 2, '0' );
      const yyyy = parseInt( $( '.countdown' ).attr( 'data-year' ) );
      const dayMonth = mm + '/' + dd + '/';
      const eventStart = dayMonth + yyyy;

      today = mm + '/' + dd + '/' + yyyy;

      const countDown = new Date( eventStart ).getTime();
      let changed = false;
      const x = setInterval( function() {
        const now = new Date().getTime();
        const distance = countDown - now;

        const rawDays = String( Math.floor( distance / ( day ) ) ).padStart( 3, '0' );
        const rawHours = String( Math.floor( ( distance % ( day ) ) / ( hour ) ) ).padStart( 2, '0' );
        const rawMinutes = String( Math.floor( ( distance % ( hour ) ) / ( minute ) ) ).padStart( 2, '0' );
        const rawSeconds = String( Math.floor( ( distance % ( minute ) ) / second ) ).padStart( 2, '0' );

        const formattedDays = llFormatNum( rawDays );
        const formattedHours = llFormatNum( rawHours );
        const formattedMinutes = llFormatNum( rawMinutes );
        const formattedSeconds = llFormatNum( rawSeconds );

        $( '.countdown .days' ).html( formattedDays ).attr( 'aria-label', rawDays + ' Days' );
        $( '.countdown .hours' ).html( formattedHours ).attr( 'aria-label', rawHours + ' Hours' );
        $( '.countdown .minutes' ).html( formattedMinutes ).attr( 'aria-label', rawMinutes + ' Minutes' );
        $( '.countdown .seconds' ).html( formattedSeconds );

        if ( !changed ) {
          $( '.countdown .seconds' ).attr( 'aria-label', rawSeconds + ' Seconds' );
          changed = true;
        }

        // do something later when date is reached
        if ( distance < 0 ) {
          clearInterval( x );
        }
        // seconds
      }, 1000 );

      function llFormatNum( num ) {
        const split = num.split( '' );
        let html = '';
        for ( let i = 0; i < split.length; i++ ) {
          html += '<span class="date-partial-block" aria-hidden="true">' + split[i] + '</span>';
        }
        return html;
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'event-countdown', COMPONENT );
} )( app );
